module.exports = __webpack_public_path__ + "img/premio3.f58192e6.png";